import { Component } from '@angular/core';
import { MobileHeaderLayoutComponent } from '../core/mobile.header.layout.component';

@Component({
    selector: 'app-mobileheaderlayoutdesktop',
    templateUrl: './mobile.header.layout.desktop.component.html',
    styleUrls: ['../css/mobile.header.layout.desktop.component.scss'],
    standalone: false
})
export class MobileHeaderLayoutDesktopComponent extends MobileHeaderLayoutComponent {
  constructor() {
    super();
  }
}
